<section class="client-portal-overview-table border-top border-dark pt-2 mb-2">
  <a class="title-nav-url" [routerLink]="titleNavUrl">{{ title }}</a>
  <app-table class="simple-table" responsiveLayout="scroll" [columns]="columns" [rows]="rows" [compact]="true">
    <table-column field="label">
      <ng-template table-cell-template let-value="value" let-column="column" let-row="row">
        @if (value | clientPortalOverviewValue; as date) {
          <a class="date-nav-url" [routerLink]="titleNavUrl" [queryParams]="{ query: date }">
            <span>{{ date }}</span>
          </a>
        }
      </ng-template>
    </table-column>
    <table-column field="value">
      <ng-template table-cell-template let-value="value" let-column="column" let-row="row">
        <span class="count-column">{{ value }}</span>
      </ng-template>
    </table-column>
  </app-table>
  <div class="footer d-flex flex-row justify-content-between">
    <span>Total</span>
    <span class="count-column">{{ total }}</span>
  </div>
</section>
